import React from "react";
import { Grid, Row, Col } from "react-bootstrap";
import MailingViewerTable from "./MailingViewerTable";
import MailingUpload from "./MailingUpload";

class MailingViewer extends React.Component {
  render() {
    const { video } = this.props;
    return (
      <Grid>
        <Row>
          <Col md={12}>
            <MailingUpload video={video} />
          </Col>
        </Row>
        <Row className="mt20">
          <Col md={12}>
            <h2 className="page-header">Lista de Mailings</h2>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <MailingViewerTable video={video} />
          </Col>
        </Row>
      </Grid>
    );
  }
}

export default MailingViewer;



// WEBPACK FOOTER //
// ./src/components/pages/Mailing/MailingViewer.js